<template>
  <span
    :style="downloadpdf === false ? 'cursor: pointer' : 'cursor: not-allowed'"
    @click="
      downloadpdf === false ? exportarPdf() : null;
      downloadpdf = true;
    "
  >
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-bind="attrs"
          v-on="on"
          size="30"
          class="ml-2"
          color="red darken-4"
        >
          <v-icon class="ml-0" dark v-if="downloadpdf === false" size="25">
            mdi-file-pdf-box
          </v-icon>
          <v-progress-circular
            indeterminate
            color="white"
            v-if="downloadpdf === true"
            size="20"
            width="3"
          ></v-progress-circular>
        </v-avatar>
      </template>
      <span>{{
        `${downloadpdf === false ? "Descargar!" : "Espere! Descargando..."}`
      }}</span>
    </v-tooltip>
  </span>
</template>
<script>
//eslint-disable
import { mapState } from "vuex";
export default {
  props: {
    xdata: Array,
    xcli: Array,
    xclisaldo:Array,
    titulo: String,
    page: String,
    namefile: String,
    tipo: Number,
  },
  data() {
    return {
      downloadpdf: false,
    };
  },
  computed: {
    ...mapState(
      [
      "dirPHP", 
      "simboloMoneda", 
      "tipoMoneda"
      ]),
  },
  methods: {
    async exportarPdf() {
      let data = {
        data: this.xdata,
        titulo: this.titulo,
        datacli: this.xcli,
        simbolomoneda:this.simboloMoneda[this.tipoMoneda],
        tipomoneda:this.tipoMoneda,
        xclisaldo:this.xclisaldo
      };

      let xUrl = `${this.dirPHP}pdf/${this.page}`;
      await fetch(xUrl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((resp) => resp.arrayBuffer())
        .then((resp) => {
          const file = new Blob([resp], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          this.downloadpdf = false;
          link.download = `${this.namefile}.pdf`;
          link.click();
        });
    },
  },
};
</script>